module.exports = __webpack_public_path__ + "static/media/sch-2.be486a9c.jpg";